<template>
  <div class="weather">
    <CommonHeader title="weather" />

    <main class="main">
      <transition name="fade" mode="out-in">
        <router-view key="view" />
      </transition>
    </main>

    <CommonFooter />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import CommonHeader from '@/components/toolbar/CommonHeader';
import CommonFooter from '@/components/toolbar/CommonFooter';

import DiaryEdit from '@/components/diary/DiaryEdit';

export default {
  name: 'Diary',
  metaInfo() {
    return {
      title: this.$t('Diary'),
    };
  },
  data() {
    return {};
  },
  created: function () {
    this.loadProject(this.$route.params._id);
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(['loadProject']),
  },
  watch: {
    $route(to, from) {
      this.loadProject(this.$route.params._id);
    },
  },
  components: {
    CommonFooter,
    CommonHeader,
    DiaryEdit,
  },
};
</script>
<style scoped>
main {
  padding: 20px;
  /* background: rgb(10,29,46); */
  /* background: linear-gradient(90deg, rgba(10,29,46,1) 0%, rgba(10,29,46,1) 70%, rgba(32,53,72,1) 100%); */
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/diary/Diary.vue